export const eventStyles: Record<
	string,
	{
		statusColor: string
		text: string
		textTitle: string
		border: string
		iconColor: string
		iconBgColor: string
	}
> = {
	published: {
		statusColor: 'bg-[#17B3C5]',
		border: 'border border-[#2A94A1]',
		textTitle: 'text-black',
		text: 'text-[#A9A9BA]',
		iconColor: 'text-[#17B3C5]',
		iconBgColor: 'bg-[#17B3C5]'
	},
	scheduled: {
		statusColor: 'bg-[#BAE9EE]',
		border: 'border border-blue-primary',
		textTitle: 'text-[#7A7A8C]',
		text: 'text-[#A9A9BA]',
		iconColor: 'text-[#17B3C5]',
		iconBgColor: 'bg-[#17B3C5]'
	},
	expired: {
		statusColor: 'bg-[#E8A5A5]',
		border: 'border border-[#B57171]',
		textTitle: 'text-[#866C69]',
		text: 'text-[#866C69]',
		iconColor: 'text-[#E57373]',
		iconBgColor: 'bg-[#E57373]'
	},
	draft: {
		statusColor: 'bg-[#D9D9D9]',
		border: 'border border-[#A8A8A8]',
		textTitle: 'text-[#7A7A8C]',
		text: 'text-[#A9A9BA]',
		iconColor: 'text-[#7A7A8C]',
		iconBgColor: 'bg-[#D9D9D9]'
	}
}
